export default __webpack_public_path__ + "static/media/icon-creative-design.dc736fa8.svg";